import React from 'react';
import type { Grade } from '../utils/grade';
type GradeBadgeProps = {
  grade: Grade;
  size?: 'sm' | 'lg';
};
export function GradeBadge({
  grade,
  size = 'sm'
}: GradeBadgeProps) {
  const lg = size === 'lg';
  return <span className={`inline-flex shrink-0 items-center justify-center rounded-xl border font-semibold tracking-tight ${lg ? 'size-20 text-4xl' : 'h-6 min-w-8 px-1.5 text-xs'}`} style={{
    color: grade.color,
    borderColor: `${grade.color}66`,
    backgroundColor: `${grade.color}14`
  }} aria-label={`Grade ${grade.grade}, ${grade.label}`} data-id="element-68" data-mp="1ysgk74yogpmt">
      {grade.grade}
    </span>;
}